import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Modal } from 'reactstrap';
import { get, post, put, del } from 'helpers/api_helper';
import Datatables from 'pages/utils/table/datatable';
import { ManageReferencesColumns } from './tableColumns';
import { REFERENCES_URL } from 'helpers/url_helper';
import { showSuccessAlert, showConfirmAlert } from "pages/utils/alertMessages";
import { AvForm, AvField } from 'availity-reactstrap-validation';

const ManageReferences = () => {
    const [isForm, setIsForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [rows, setRows] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, Search: '' });

    const fetchData = async () => {
        setLoading(true);
        const { success, body } = await get(`${REFERENCES_URL}?page=${pagination.page}&limit=${pagination.limit}&search=${pagination.Search}`);
        if (success) {
            setRows(body);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [pagination]);

    const handleToggle = () => {
        setIsForm(!isForm);
        setEditMode(false);
        setEditingId(null);
        setFormData({});
        setLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        const url = editMode ? `${REFERENCES_URL}/${editingId}` : REFERENCES_URL;
        const method = editMode ? put : post;

        const { success, body } = await method(url, formData);

        if (success) {
            showSuccessAlert(editMode ? 'Reference updated successfully!' : 'Reference created successfully!');
            setIsForm(false);
            setFormData({});
            setEditMode(false);
            setEditingId(null);
            fetchData();
        }
    };

    const handleInvalidSubmit = () => {
        alert("Please enter the required fields.");
    };

    const handleEdit = (row) => {
        setFormData(row);
        setEditMode(true);
        setEditingId(row.id);
        setIsForm(true);
        setLoading(false);
    };

    const handleDelete = async (id, sts) => {
        const action = sts === 1 ? 'De-activate' : 'Activate';

        const { isConfirmed } = await showConfirmAlert(`${action} Reference`, `Do you really want to ${action} this Reference?`,
            `Yes, ${action} it!`, `${action}d!`, `Reference has been ${action}d successfully.`);

        if (isConfirmed) {
            const { success } = await del(`${REFERENCES_URL}/${id}?sts=${sts}`);
            if (success) {
                fetchData();
            }
        }
    };

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Datatables
                        isSearch={true}
                        columns={ManageReferencesColumns({ "edit": handleEdit, "delete": handleDelete }, pagination)}
                        showTableOnly={true}
                        rowsLength={rows?.totalItems || 0}
                        rows={rows.items || []}
                        keyField={'id'}
                        handleAddButton={handleToggle}
                        title="All Referral Sources"
                        isAdd={true}
                        isTableHead={true}
                        loading={loading}
                        ssr={setPagination}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={isForm} toggle={handleToggle} size="xl" centered>
                <AvForm onValidSubmit={handleSubmit} onInvalidSubmit={handleInvalidSubmit} model={formData}>
                    <div className="modal-header">
                        <h5 className="modal-title font-weight-bold">
                            {editMode ? 'Update' : 'Create'} Referral Source
                        </h5>
                        <button type="button" className="btn-close" onClick={handleToggle} aria-label="Close" />
                    </div>
                    <div className="modal-body p-4">
                        <Row className="g-3">
                            <Col md={12}>
                                <div className="mb-2">
                                    <AvField
                                        name="title"
                                        label="Referral Source / Channel Title *"
                                        type="text"
                                        placeholder="e.g. Google Search, Practo, Word of Mouth, Dr. Sharma Reference"
                                        value={formData.title || ''}
                                        onChange={handleChange}
                                        required
                                        errorMessage="Please enter Reference Title"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" onClick={handleToggle}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Processing...' : (editMode ? 'Update Reference' : 'Save Reference')}
                        </button>
                    </div>
                </AvForm>
            </Modal>
        </React.Fragment>
    );
};

export default ManageReferences;